module.exports = __webpack_public_path__ + "fonts/sourcesansprolightitalic.9c3fcb0e.woff2";